var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircledArrowLeft = function SvgCircledArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#747986",
    fillRule: "evenodd",
    d: "M42.8 32.171a1.2 1.2 0 0 0-1.2-1.2H22.4a1.2 1.2 0 0 0 0 2.4h19.2a1.2 1.2 0 0 0 1.2-1.2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#747986",
    fillRule: "evenodd",
    d: "M31.477 23.094a1.2 1.2 0 0 0-1.697 0l-8.229 8.229a1.2 1.2 0 0 0 1.697 1.697l8.229-8.229a1.2 1.2 0 0 0 0-1.697Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#747986",
    fillRule: "evenodd",
    d: "M31.477 41.248a1.2 1.2 0 0 0 0-1.697l-8.229-8.229a1.2 1.2 0 1 0-1.697 1.698l8.229 8.228a1.2 1.2 0 0 0 1.697 0Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.194,
    height: 63.194,
    x: 63.597,
    y: 63.597,
    stroke: "#747986",
    strokeWidth: 0.806,
    rx: 31.597,
    transform: "rotate(-180 63.597 63.597)"
  })));
};
export default SvgCircledArrowLeft;